const getDate = (string = null) => {
    const dateObj = string ? new Date(string) : new Date()

    const year = dateObj.getFullYear()
    const month = dateObj.getMonth() + 1
    const day = dateObj.getDate() 

    const yearWihZero = year > 9 ? year : '0' + year
    const monthWihZero = month > 9 ? month : '0' + month
    const dayWihZero = day > 9 ? day : '0' + day

    return yearWihZero + '-' + monthWihZero + '-' + dayWihZero
}

export default getDate